import churchIcon from "./churchIcon.png";
import lunchIcon from "./lunchIcon.png";
import "./styles.css";

export default function Locations() {
    const locations = [
        {
            id: 1,
            hour: "12:00 pm - 1:00 pm",
            title: "EUCARISTÍA",
            place: "MONTE SAN FRANCISCO\nCAPILLA SANTO HERMANO PEDRO",
            city: "Santa Catarina Pinula",
            icon: churchIcon,
            link: "https://maps.app.goo.gl/G32Fb8AwsP7Avnaq5",
        },
        {
            id: 2,
            hour: "3:00 pm - 9:00 pm",
            title: "RECEPCIÓN",
            place: "LA FLORESTA\nEVENT CENTER",
            city: "San José Pinula",
            icon: lunchIcon,
            link: "https://maps.app.goo.gl/hPYoJ1Kq8He84boy8",
        },
    ];

    return (
        <section className="locations-section">
            <div className="locations-container">
                {locations.map((item) => (
                    <article className="location-card" key={item.id}>
                        <img src={item.icon} alt={item.title} className="location-icon" />

                        <p className="location-hour">{item.hour}</p>
                        <h3 className="location-title">{item.title}</h3>
                        <p className="location-place">{item.place}</p>
                        <p className="location-city">{item.city}</p>

                        <a
                            href={item.link}
                            target="_blank"
                            rel="noreferrer"
                            className="location-button"
                        >
                            Ver ubicación
                        </a>
                    </article>
                ))}
            </div>
        </section>
    );
}